const mapUrl = 'https://map.qq.com/api/gljs'
const apiKey = '7EWBZ-DTVA2-PRQUX-CZFGS-SEZBF-4JBOZ'
const version = '1.exp'

const API = {
  getLatlonByIp: 'https://apis.map.qq.com/ws/location/v1/ip',
  address: 'https://apis.map.qq.com/ws/geocoder/v1/',
  driving: 'https://apis.map.qq.com/ws/direction/v1/driving/',
  suggestion: 'https://apis.map.qq.com/ws/place/v1/suggestion',
  explore: 'https://apis.map.qq.com/ws/place/v1/explore',
  district: 'https://apis.map.qq.com/ws/district/v1/list',
  getAccurateLatlon: 'https://apis.map.qq.com/tools/geolocation/min?referer=myapp'
}

export default {
  mapUrl,
  apiKey,
  version,
  API
}
